import script from "./Register.vue?vue&type=script&setup=true&lang=js"
export * from "./Register.vue?vue&type=script&setup=true&lang=js"

import "./Register.vue?vue&type=style&index=0&id=6c81b3f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c81b3f0"]])

export default __exports__